import { useCommentsContext } from './CommentsContext';
import { Comment } from './comments.graphql';

export const useNodeComments = (guideNodeId?: string): Comment[] => {
  const { comments, isCommentsEnabled } = useCommentsContext();
  if (!guideNodeId || !isCommentsEnabled) return [];
  return comments.filter((comment) => comment.guideNodeId === guideNodeId);
};
